/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide2title1Inputs */

const he_extension_slide2title1 = /** @type {(inputs: Extension_Slide2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סטטיסטיקות מתקדמות`)
};

const en_extension_slide2title1 = /** @type {(inputs: Extension_Slide2title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Statistics`)
};

/**
* | output |
* | --- |
* | "Advanced Statistics" |
*
* @param {Extension_Slide2title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide2title1 = /** @type {((inputs?: Extension_Slide2title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide2title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide2title1(inputs)
	return en_extension_slide2title1(inputs)
});
export { extension_slide2title1 as "extension_slide2Title" }